import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Ensina ao tailwind-merge os nomes que o lume.css adiciona; sem isso `h-control h-10` sobrevive
// inteiro e a ordem de emissão do Tailwind decide quem vence.
const merge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['control', 'control-sm', 'control-lg', 'control-x', 'stack', 'icon', 'row'],
      radius: ['control', 'card'],
      shadow: ['1', '2', '3', 'focus', 'invalid'],
      text: ['control', 'field', 'body'],
    },
  },
});

/** Junta classes deixando o último utilitário do mesmo grupo vencer. */
export function cn(...values: ClassValue[]): string {
  return merge(clsx(values));
}
